import { __decorate } from 'tslib';
import { Input, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { tuiDefaultProp } from '@taiga-ui/cdk';

import * as ɵngcc0 from '@angular/core';

const _c0 = ["*"];
var TuiRadioGroupComponent_1;
let TuiRadioGroupComponent = TuiRadioGroupComponent_1 = class TuiRadioGroupComponent {
    constructor() {
        this.name = `tui-radio-group-${TuiRadioGroupComponent_1.index++}`;
    }
};
TuiRadioGroupComponent.ɵfac = function TuiRadioGroupComponent_Factory(t) { return new (t || TuiRadioGroupComponent)(); };
TuiRadioGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiRadioGroupComponent, selectors: [["tui-radio-group"]], inputs: { name: "name" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function TuiRadioGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
TuiRadioGroupComponent.index = 0;
__decorate([
    Input(),
    tuiDefaultProp()
], TuiRadioGroupComponent.prototype, "name", void 0);

let TuiRadioGroupModule = class TuiRadioGroupModule {
};
TuiRadioGroupModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiRadioGroupModule });
TuiRadioGroupModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiRadioGroupModule_Factory(t) { return new (t || TuiRadioGroupModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiRadioGroupComponent, [{
        type: Component,
        args: [{
                selector: 'tui-radio-group',
                template: "<ng-content></ng-content>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { name: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiRadioGroupModule, { declarations: [TuiRadioGroupComponent], exports: [TuiRadioGroupComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiRadioGroupModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiRadioGroupComponent],
                exports: [TuiRadioGroupComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiRadioGroupComponent, TuiRadioGroupModule };

//# sourceMappingURL=taiga-ui-kit-components-radio-group.js.map